import { loadDetail } from '../api/new-index.js'
import {getDriverGPSServerInstance} from "@/data-services/driver-gps-service";
import { getRoute } from '@/utils/add-route/catch-api'
import Vue from 'vue'
const state = {
    namespaced: true,
    /**
     * @isShowRightBulletFrame  assgin之后显示右侧弹框
     * 
     */
    state: {
        loadDatailList: {},
        driverData: [],
        assginShow: {},
        routeData: {},
        isRequest: false,
        detailHeaderLoading: true,
        detailRequestError: false,
        isRefresh: false,
        currentStatus: undefined,
        catchLoadInfo: [],
        assign: {}
    },
    mutations: {
      /**
       * @GET_DRIVERLIST  获取司机列表
       */
      GET_TASK_DETAIL (state, driverList) {
        state.loadDatailList = driverList;
        state.currentStatus = driverList.loadInfo?.statusLoad
        if(driverList.loadInfo?.loadId) {
          state.detailHeaderLoading = false;
        }
        let currentIndex = state.catchLoadInfo.findIndex(item => item.id === driverList.loadInfo.id);
        if(state.catchLoadInfo[currentIndex]?.id !== driverList.loadInfo.id) {
          state.catchLoadInfo.push(driverList.loadInfo)
        }
      },
      GET_DETAIL_LOADING(state, status) {
        state.detailHeaderLoading = status
      },
      GET_DETAIL_REQUEST_ERROR(state, status) {
        state.detailRequestError = status
      },
      GET_DRIVER_GPS (state, data) {
        state.driverData = data;
      },
      SHOW_ASSGIN_DIA (state, boolean) {
        state.assginShow = boolean
      },
      GET_ROUTE_LIST (state, routeData) {
        state.routeData = routeData
      },
      CLEAR_DATA (state, data) {
        state.loadDatailList = data.data
        state.detailHeaderLoading = data.loading
        state.detailRequestError = false
      },
      REQUEST_ID (state, data) {
        state.isRequest = data
      },
      IS_REFRESH (state, data) {
        state.isRefresh = data
      },
      CATCH_LOAD_INDO(state, dataInfo) {
        let {data, type} = dataInfo;
        if(type === 'add') {
          state.catchLoadInfo.push(data)
        }
        if(type === 'edit') {
          console.log(state.catchLoadInfo,'',data,'65');
          let findIndex = state.catchLoadInfo.findIndex(item => item.id === data.id);
          state.catchLoadInfo.splice(findIndex, 1, data)
        }
        console.log(dataInfo, state.catchLoadInfo,'69');
      },
      SET_DISTANCE(state, data) {
        state.assign = data
        console.log(JSON.stringify(state.assign),79);
      }
    },
    actions: {
      getTaskList ({ commit }, taskID) {
        loadDetail(taskID).then(( res ) => {
            if(res.code === 200) {
              let datas = new Promise((resolve) => {
                resolve(res.data)
              })
              datas.then((Res) => {
                commit('GET_TASK_DETAIL', Res)
                let IsHasDistance = Res.loadInfo.distance && Res.loadInfo.distance !== 0 ? false : true
                getRoute(taskID, IsHasDistance) 
                .then(( res ) => {
                  commit('GET_ROUTE_LIST', {data:res.route,loading: false, allData: res.route})
                })
                .catch((error) => {
                    if(error) {
                      Vue.$message.error('Unable to create a route for the selected locations.')
                      commit('GET_ROUTE_LIST', {data:[],loading: false,allData: []})
                    }
                })
                // 
              })
            }else {
              Vue.$message.error(res.message)
            }
            
        }).catch(() => {
          commit('GET_DETAIL_REQUEST_ERROR', true)
          commit('GET_DETAIL_LOADING', false)
        })
      },
      setTaskDetail({ commit }, detail) {
        commit('GET_TASK_DETAIL', detail)
      },
      getDiverGps({ commit }) {
        getDriverGPSServerInstance().getList().data.then(( res ) => {
          commit('GET_DRIVER_GPS', res.data)
        })
      },
      showAssgin({ commit }, boolean) {
        commit('SHOW_ASSGIN_DIA', boolean)
      },
      getRouteList({ commit }, data) {
        commit('GET_ROUTE_LIST', data)
      },
      requesId({ commit }, data) {
        commit('REQUEST_ID', data)
      },
      clearData({ commit }, data) {
        commit('CLEAR_DATA', data)
      },
      refreshData({ commit }, data) {
        commit('IS_REFRESH', data)
      },
      pushLoadInfo({ commit }, data) {
        commit('CATCH_LOAD_INDO', data)
      },
      setDistance({ commit }, data) {
        commit('SET_DISTANCE', data)
      }
    },
  }
  
  export default state
  